import { LocationObjectType } from 'models/location.model';
import { MemberListType } from 'models/member.model';
import { CreateGroupOrderType } from 'models/order.model';

class GroupOrderService {
  AddMember = (members: MemberListType[], setMembers: (members: string[]) => void) => {
    const membersIds = members.map((member) => {
      return member.user_id;
    });
    setMembers(membersIds);
  };
  AddLimit = (
    limit: string,
    setState: (args: (prevState: CreateGroupOrderType) => CreateGroupOrderType) => void
  ) => {
    setState((prevState: CreateGroupOrderType) => ({
      ...prevState,
      group_spend_limit: limit
    }));
  };
  GetDefaultMembers = (members: MemberListType[], membersIds: string[]) => {
    if (!members) return [];
    const selectedMembersList = members.filter((member) => membersIds.includes(member.user_id));
    return selectedMembersList.map((member) => ({
      id: member.id,
      user_id: member.user_id,
      firstName: member.user.first_name,
      lastName: member.user.last_name
    }));
  };
  RearrangeLocations = (locations: LocationObjectType[]): LocationObjectType[] => {
    const homeLocation = locations.find((location) => location.name.toLowerCase() === 'home');
    const workLocation = locations.find((location) => location.name.toLowerCase() === 'work');
    const otherLocations = locations.filter(
      (location) => location.name.toLowerCase() !== 'home' && location.name.toLowerCase() !== 'work'
    );

    const rearrangedLocations = [];
    if (homeLocation) rearrangedLocations.push(homeLocation);
    if (workLocation) rearrangedLocations.push(workLocation);
    rearrangedLocations.push(...otherLocations);

    return rearrangedLocations;
  };
}

export default new GroupOrderService();
